import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { payAccountRetain, payAccountRetain_currency } from "@/api/dataAll/payAccountRetain";
import * as echarts from "echarts";
import retainAllList from './components/retainAllList.vue';
export default {
  name: "payAccountRetain",
  mixins: [tabulation],
  components: {
    retainAllList: retainAllList
  },
  data: function data() {
    return {
      value2: [],
      tableData: [],
      tableHeader: [this.$t('newUserCount'), this.$t('activeUserCount'), this.$t('totalLoginCount'), this.$t('maxOnlineCount')],
      dates: [],
      datas: [],
      series: [],
      selectedArr: {},
      intReq: [],
      Dynamic: [],
      screen: [],
      PrimitiveDy: [],
      cellStylekeys: ["retain"],
      dimenList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 2
      }]
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.searchData.kind = 1;
                _this.PrimitiveDy = [];
                reqFn = _this.currencyClose ? payAccountRetain_currency : payAccountRetain;

                _this.searchClickPoints(reqFn, 1);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this2 = this;

      var qres = JSON.parse(JSON.stringify(lists));
      var res = {
        data: {
          totalSum: 0,
          data: {},
          avgData: {}
        }
      };
      qres.forEach(function (i) {
        res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);
        res.data.totalSum = res.data.totalSum + Number(i.totalSum);

        for (var k in i.avgData) {
          var nums = i.data[i.searchdate.starttime].retain_pnum[k] == '/' ? 0 : Number(i.data[i.searchdate.starttime].retain_pnum[k]);
          res.data.avgData[k] = !res.data.avgData[k] ? nums : res.data.avgData[k] + nums;
        }
      });

      for (var i in res.data.avgData) {
        res.data.avgData[i] = (res.data.totalSum ? (res.data.avgData[i] / res.data.totalSum * 100).toFixed(2) : 0) + '%';
      } // if(this.currencyClose && !this.searchData.currency_info){
      //   this.$message.error('请选择货币类型')
      //   return
      // }


      this.timeInterval();
      this.tableData = [];
      this.screen = [];
      this.series = [];
      this.dates = [];
      this.datas = [];
      var newData = res.data.data;

      for (var _i in newData) {
        this.dates.push(_i);
        var data = {
          date: _i,
          pnum: newData[_i].pnum
        };
        var o = {
          name: _i,
          type: "line",
          data: [],
          smooth: true
        };
        var arr = Object.keys(newData[_i].retain);
        var DynamicList = [];

        for (var k in newData[_i].retain) {
          newData[_i].retain[k] = this.zhuan([newData[_i].retain[k]])[0];
          data["retain" + k] = newData[_i].retain[k];
          o.data.push(newData[_i].retain[k]);

          if (DynamicList.length < arr.length) {
            var a = k == 2 ? this.$t('nextDayPrefix') : k;
            DynamicList.push({
              label: "".concat(a).concat(this.$t('rrSuffix')).concat(k),
              prop: "retain" + k,
              tableText: k == 2 ? "".concat(this.$t('rraSuffix')).concat(k) : "".concat(this.$t('rrPrefix')).concat(k),
              desc: k == 2 ? this.$t('nextDayAccountRetention') : ""
            });
          }
        }

        if (!this.screen.length) {
          this.screen = DynamicList.map(function (item) {
            return item.prop;
          });
          this.PrimitiveDy = DynamicList;
        }

        this.screenControls();
        this.series.push(o);
        this.tableData.push(data);
      } // 总计数据处理


      var total = {
        date: this.$t('weightedAverageRetention'),
        pnum: res.data.totalSum
      };

      for (var _k in res.data.avgData) {
        total["retain" + _k] = this.zhuan([res.data.avgData[_k]])[0];
      }

      this.tableData.push(total);
      this.$nextTick(function () {
        _this2.getTableRight();
      });
      this.getechart();
    },
    screenControls: function screenControls() {
      var _this3 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this3.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this3.Dynamic = list;
      }, 50);
    },
    zhuan: function zhuan(list) {
      var n = [];
      list.forEach(function (item) {
        n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0);
      });
      return n;
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("payAccountRetainEchart");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: this.$t('payAccountRetentionRate')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: this.dates,
          width: "80%" // selected: this.selectedArr,

        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.label;
          })
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 100
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('dateSlashDate'),
        prop: "date"
      }, {
        label: this.$t('pnumSlashDnpu'),
        prop: "pnum"
      }].concat(_toConsumableArray(this.Dynamic));
      var data = JSON.parse(JSON.stringify(this.tableData));
      this.Dynamic.forEach(function (item) {
        data.forEach(function (i) {
          i[item.prop] = i[item.prop] + "%";
        });
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    },
    gotoDetailList: function gotoDetailList(row, props) {
      console.log("row==", row, props);
      var date = row.date;
      var retainDay = props.replace('retain', '');
      var _this$searchData = this.searchData,
          game_id = _this$searchData.game_id,
          env_id = _this$searchData.env_id,
          special_product_id = _this$searchData.special_product_id,
          server_id = _this$searchData.server_id,
          is_roll = _this$searchData.is_roll;
      var query = {
        key: 'payAccountRetain',
        register_date: date,
        retain_day: retainDay,
        game_id: game_id,
        env_id: env_id,
        special_product_id: special_product_id,
        server_id: server_id,
        is_roll: is_roll
      };
      this.$refs.retainAllList.init(query);
    }
  }
};